import React, { Suspense } from "react";
import { primeLazy } from "./lazyPage";

// A large illustration drawn as an inline SVG component, downloaded apart
// from the page's code. Inline SVGs are compiled into JavaScript, so the
// home page's below-the-fold drawings (one of them carries a 270 KB embedded
// image) were a third of its main bundle. Until the drawing arrives, an empty
// <svg> with the same size attributes holds its place, so nothing moves; if
// it cannot be downloaded, that empty box simply stays.
//
// `eager`: start the download right away (when this module is evaluated)
// instead of at the first render, for drawings above the fold: they then
// download while the app is still checking who is signed in.
export const lazySvg = (load, { width, height, viewBox, eager = false }) => {
  const Placeholder = ({ className, style }) => (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className} style={style} />
  );
  let promise = null;
  const fetchDrawing = () => {
    if (!promise) {
      promise = load()
        .catch(load)
        .then((module) => ({ default: module.ReactComponent }))
        .catch(() => ({ default: Placeholder }));
    }
    return promise;
  };
  if (eager) fetchDrawing();
  const Drawing = React.lazy(fetchDrawing);
  const LazySvg = (props) => (
    <Suspense fallback={<Placeholder className={props.className} style={props.style} />}>
      <Drawing {...props} />
    </Suspense>
  );
  // Lets a page that is already on screen (prerendered) wait for the drawing
  // before React draws it again, so it is not swapped for the empty box.
  LazySvg.prime = () => primeLazy(Drawing);
  return LazySvg;
};
